// extracted by mini-css-extract-plugin
export default {"w-full":"Balance_w-full__v5m0Y","negative":"Balance_negative__7UmoQ","positive":"Balance_positive__kwjsn","background":"Balance_background__zFZxc"};